import { render, staticRenderFns } from "./PersonalDataTab.vue?vue&type=template&id=a38bc8fc&scoped=true"
import script from "./PersonalDataTab.vue?vue&type=script&lang=js"
export * from "./PersonalDataTab.vue?vue&type=script&lang=js"
import style0 from "./PersonalDataTab.vue?vue&type=style&index=0&id=a38bc8fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38bc8fc",
  null
  
)

export default component.exports